import {
  useUserOnboardingDisable,
  useUserOnboardingEnable,
  useUserPreferences
} from "@/api";
import { TypographyMuted } from "@/components/typography/Muted";
import TooltipHover from "@/components/ui/TooltipHover";

function ToggleOnboarding() {
  const { data, error } = useUserPreferences();
  const [onboardingEnable] = useUserOnboardingEnable();
  const [onboardingDisable] = useUserOnboardingDisable();

  if (error) console.error(error);

  function handleChange() {
    if (data?.onboardingDisabled) onboardingEnable();
    else onboardingDisable();
  }

  return (
    <TooltipHover
      asChild
      text="Make onboarding less disruptive to your work. Dismissing onboarding will set your start page to the App Gallery."
    >
      <div className="flex items-center gap-2">
        <TypographyMuted className="select-none">
          Dismiss onboarding
        </TypographyMuted>
        <input
          className="cursor-pointer"
          checked={!!data?.onboardingDisabled}
          onChange={handleChange}
          type="checkbox"
        />
      </div>
    </TooltipHover>
  );
}

export default ToggleOnboarding;
